import map from 'lodash/map';

import styles from './CardParameters.module.scss';
import isEmpty from 'lodash/isEmpty';
import CardParameterItem from '@/app/components/product/cardParameters/CardParameterItem';
import filter from 'lodash/filter';
import { PRODUCT_VARIANT_NAME_PARAM_HASH } from '@/constants/ProductConstants';
import CardInlineParameters from '@/app/components/product/cardParameters/CardInlineParameters';

const CardParameters = ({
  product = [],
  className = '',
  isInline = false,
  isCard = false,
  emphasize = false,
}) => {
  let parameters =  filter(product?.cardParameters, param => param?.hash !== PRODUCT_VARIANT_NAME_PARAM_HASH);
  if (isEmpty(parameters)) {
    parameters = filter(product?.detailedParameters, param => param?.visibleProductCard === 1 && param?.hash !== PRODUCT_VARIANT_NAME_PARAM_HASH);
  }

  if (isInline) {
    return <CardInlineParameters parameters={parameters} className={className} emphasize={emphasize} />;
  }

  return (
    <div
      className={`${styles.parameters} ${
        isCard ? 'max-w-[240px] h-[34px] overflow-hidden flex-wrap' : ''
      } ${className}`}
    >
      {map(parameters, (parameter, index) => (
        <CardParameterItem key={index} parameter={parameter} />
      ))}
    </div>
  );
};

export default CardParameters;
